import { NgIf } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormLoginComponent } from '../forms/login/login.component';
import { FormSignupComponent } from '../forms/signup/signup.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-common-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.scss'],
  standalone: true,
  imports: [NgIf, ModalComponent, FormLoginComponent, FormSignupComponent],
})
export class ModalLoginComponent {
  @ViewChild('modal')
  modal!: ModalComponent;

  signUp: boolean = false;

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }
}
